(function ($) {
  'use strict';

  function setFavoriteState($btn, isFavorite) {
    var label = isFavorite ? $btn.attr('data-label-remove') : $btn.attr('data-label-add');

    $btn.toggleClass('is-favorite', isFavorite);
    $btn.attr('aria-pressed', isFavorite ? 'true' : 'false');
    if (label) {
      $btn.attr('title', label).attr('aria-label', label);
    }
  }

  $(document).ready(function () {
    $(document).on('click', '.product__favorite-btn', function (e) {
      var $btn = $(this);

      if ($btn.is(':disabled') || $btn.attr('disabled') || $btn.data('is-logged-in') == '0') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      e.preventDefault();
      e.stopPropagation();

      var productId = $btn.data('product-id');

      if ($btn.hasClass('is-loading')) {
        return;
      }

      // Optimistic UI update
      var wasFavorite = $btn.hasClass('is-favorite');
      setFavoriteState($btn, !wasFavorite);
      $btn.addClass('is-loading');

      var restEndpoint = (typeof vectorFavoritesData !== 'undefined' && vectorFavoritesData.restUrl)
        ? vectorFavoritesData.restUrl + '/toggle'
        : '/wp-json/vector/v1/favorites/toggle';

      var nonce = (typeof vectorFavoritesData !== 'undefined' && vectorFavoritesData.nonce)
        ? vectorFavoritesData.nonce
        : '';

      $.ajax({
        url: restEndpoint,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ product_id: productId }),
        beforeSend: function (xhr) {
          if (nonce) {
            xhr.setRequestHeader('X-WP-Nonce', nonce);
          }
        },
        success: function (response) {
          $btn.removeClass('is-loading');
          if (response && response.success) {
            setFavoriteState($btn, !!response.is_favorite);
          } else {
            // Revert on failure
            setFavoriteState($btn, wasFavorite);
          }
        },
        error: function () {
          $btn.removeClass('is-loading');
          // Revert on network error
          setFavoriteState($btn, wasFavorite);
        }
      });
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/scripts/favorites.js